import { WorldPoint } from './grid';
import { AtlasCoord } from './utils';

export enum Mineable {
    Steel,
    Uranium,
    Rock,
}

function image_for_mineable(m: Mineable): AtlasCoord {
    switch (m) {
        case Mineable.Uranium:
            return { i: 1, j: 2 };

        case Mineable.Steel:
            return { i: 3, j: 2 };

        case Mineable.Rock:
            return { i: 2, j: 2 };
    }
}

export class Deposit {
    public mineable: Mineable
    public position: WorldPoint

    constructor(m: Mineable, wp: WorldPoint) {
        this.mineable = m
        this.position = wp
    }

    image(): AtlasCoord {
        return image_for_mineable(this.mineable)
    }
}

